<gt-header *ngIf="showHeader"></gt-header>
<ion-content>
  <ng-container *ngIf="data$ | async as data">
    <div class="flex items-center justify-between">
      <div *ngIf="!showHeader"></div>
      <ion-icon *ngIf="showHeader" class="text-size-32" name="gt-back" (click)="navController.back()"></ion-icon>
      <div class="uppercase font-semibold text-md">{{ 'ONBOARDING.REGISTER.PAYMENT.TITLE' | transloco }}</div>
      <div class="w-8"></div>
    </div>
    <div class="flex justify-between items-center">
      <h3>
        {{ data.inscription.category | categoryName | async }}
      </h3>
      @if (data.inscription.level) {
        <gt-level-badge style="margin-top: 16px; margin-bottom: 12px" [level]="data.inscription.level"></gt-level-badge>
      }
    </div>
    <div>
      <div class="pb-4 flex flex-col gap-3" *ngIf="data.inscription.category">
        <div
          *ngFor="let rate of data.edition.rates | editionRates: data.inscription.category"
          [ngClass]="{ 'opacity-30': rate.id !== currentRate, 'bg-primary border-primary': rate.id === currentRate }"
          class="border rounded border-black flex flex-col gap-2 p-2"
        >
          <div class="uppercase font-extrabold text-lg text-black tracking-widest">{{ rate.name }}</div>
          <div class="flex gap-4 items-center">
            <span class="uppercase font-extrabold text-lg text-black tracking-widest"
              >{{ rate | ratePrice: data.inscription.level : data.edition.levelPricesEnabled }}€</span
            >
            <span class="text-sm text-black"
              >{{ rate.startDate | date: 'dd MMMM YYYY' }} - {{ rate.endDate | date: 'dd MMMM YYYY' }}</span
            >
          </div>
        </div>
      </div>
      <div class="pb-4 flex flex-col gap-3" *ngIf="data.inscription.isPremium">
        <div
          *ngIf="data.edition | premiumPack: data.inscription.premiumPack?.id ?? null as premiumPack"
          class="border rounded bg-primary border-primary flex flex-col gap-2 p-2"
        >
          <div class="uppercase font-extrabold text-lg text-black tracking-widest">
            {{ premiumPack.name }}
          </div>
          <div class="flex gap-4 items-center">
            <span class="uppercase font-extrabold text-lg text-black tracking-widest">{{ premiumPack.price }}€</span>
            <span class="text-sm text-black">{{ premiumPack.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <h3 class="mt-4">{{ 'ONBOARDING.REGISTER.PAYMENT.EXTRAS_TITLE' | transloco }}</h3>
    <div class="py-4 flex flex-col gap-3">
      <div
        class="border rounded border-secondary flex flex-col gap-2 p-2"
        *ngFor="let extraService of extraServices$ | async; let index = index"
      >
        <div class="text-destacadoM extra-service-title">
          {{ extraService.name }}
          <span *ngIf="extraService.byPerson">{{ 'ONBOARDING.REGISTER.PAYMENT.BY_PERSON' | transloco }}</span>
        </div>
        <div class="text-sm">{{ extraService.description }}</div>
        <div *ngIf="!extraService.payOffline && !extraService.mandatory" class="flex justify-center gap-8 items-center">
          <gt-button
            (click)="
              updateServiceQuantity(
                extraService.id,
                getServiceByExtraServiceId(extraService.id)?.quantity
                  ? getServiceByExtraServiceId(extraService.id)!.quantity - 1
                  : 0
              )
            "
            [disabled]="
              paymentOption === 'registration' ||
              !getServiceByExtraServiceId(extraService.id)?.quantity ||
              getServiceByExtraServiceId(extraService.id)?.quantity === 0
            "
            [onlyIcon]="'onlyIcon'"
            class="controls-buttons"
            ><ion-icon name="gt-minus"></ion-icon
          ></gt-button>
          <div class="text-counter">
            {{ getServiceByExtraServiceId(extraService.id)?.quantity ?? 0 }}
            <span *ngIf="extraService.byPerson"> / {{ extraService.maxQuantity }}</span>
          </div>
          <gt-button
            (click)="
              updateServiceQuantity(
                extraService.id,
                getServiceByExtraServiceId(extraService.id)?.quantity
                  ? getServiceByExtraServiceId(extraService.id)!.quantity + 1
                  : 1
              )
            "
            [disabled]="
              paymentOption === 'registration' ||
              (extraService.byPerson &&
                getServiceByExtraServiceId(extraService.id)?.quantity === extraService.maxQuantity) ||
              (!extraService.byPerson &&
                extraService.maxQuantity === getServiceByExtraServiceId(extraService.id)?.quantity)
            "
            [onlyIcon]="'onlyIcon'"
            class="controls-buttons"
            ><ion-icon name="gt-plus"></ion-icon
          ></gt-button>
        </div>
        <hr class="m-2" />
        <div class="font-extrabold text-lg text-black tracking-widest flex justify-center gap-2">
          @if (extraService.byPerson) {
            {{ extraService.price }}€ x{{ data.inscription.summonedParticipants?.length }}
          } @else {
            {{ extraService.price }}€
          }
        </div>
        <div class="flex flex-col items-center">
          <div *ngIf="extraService.mandatory" class="text-danger uppercase font-semibold">
            {{ 'ONBOARDING.REGISTER.PAYMENT.MANDATORY' | transloco }}
          </div>
          <small class="text-center">
            {{
              (extraService.payOffline
                ? 'ONBOARDING.REGISTER.PAYMENT.MANDATORY_PAYMENT_OFFLINE_DESC'
                : 'ONBOARDING.REGISTER.PAYMENT.MANDATORY_DESC'
              ) | transloco
            }}
          </small>
        </div>
      </div>
    </div>
    <ion-radio-group [(ngModel)]="paymentOption" (ionChange)="onPaymentOptionChange()">
      <div class="py-4 flex flex-col gap-3">
        <div class="flex flex-col gap-2 cursor-pointer" (click)="paymentOption = 'all'; onPaymentOptionChange()">
          <div class="flex gap-2 items-start">
            <ion-radio [value]="'all'"></ion-radio>
            <div class="flex flex-col gap-1">
              <div class="font-bree text-lg font-bold">
                {{ 'ONBOARDING.REGISTER.PAYMENT.PAY_ALL_NOW' | transloco }}
              </div>
              <div class="text-sm">
                {{ 'ONBOARDING.REGISTER.PAYMENT.PAY_ALL_NOW_DESC' | transloco }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex flex-col gap-2 cursor-pointer"
          (click)="paymentOption = 'registration'; onPaymentOptionChange()"
        >
          <div class="flex gap-2 items-start">
            <ion-radio [value]="'registration'"></ion-radio>
            <div class="flex flex-col gap-1">
              <div class="font-bree text-lg font-bold">
                {{ 'ONBOARDING.REGISTER.PAYMENT.PAY_REGISTRATION_ONLY' | transloco }}
              </div>
              <div class="text-sm">
                {{ 'ONBOARDING.REGISTER.PAYMENT.PAY_REGISTRATION_ONLY_DESC' | transloco }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-radio-group>
    <h3 class="mt-4">{{ 'ONBOARDING.REGISTER.PAYMENT.PAYMENT_METHOD_TITLE' | transloco }}</h3>
    <div class="flex gap-3 justify-center">
      <gt-button
        (click)="paymentMethod = 'REDSYS'"
        class="payment-method-button flex-1 ![--height:112px]"
        iconPosition="top"
        [expand]="'max'"
        [color]="null"
        [ngClass]="{ 'payment-method-button-activated': paymentMethod === 'REDSYS' }"
      >
        <ion-icon name="card-outline" class="text-4xl"></ion-icon>
        {{ 'ONBOARDING.REGISTER.PAYMENT.PAYMENT_METHOD_CARD' | transloco }}
      </gt-button>
      <gt-button
        (click)="paymentMethod = 'BANK'"
        class="payment-method-button flex-1 ![--height:112px]"
        [expand]="'max'"
        [color]="null"
        iconPosition="top"
        [ngClass]="{ 'payment-method-button-activated': paymentMethod === 'BANK' }"
      >
        <ion-icon name="gt-bank" class="text-4xl"></ion-icon>
        {{ 'ONBOARDING.REGISTER.PAYMENT.PAYMENT_METHOD_BANK' | transloco }}
      </gt-button>
    </div>
    <div class="w-full bg-secondary fixed bottom-0 left-0 z-50 custom-shadow px-6 pt-2 pb-8">
      <div class="h-full max-w-lg mx-auto flex items-center justify-between">
        <div class="flex flex-col">
          <div class="uppercase font-extrabold text-lg text-black tracking-widest">
            {{ 'ONBOARDING.REGISTER.PAYMENT.TOTAL' | transloco }}
          </div>
          <div class="uppercase font-extrabold text-2xl text-black">{{ total }} €</div>
        </div>
        <gt-button
          (click)="confirm()"
          *ngIf="!paymentMethod || paymentMethod === 'REDSYS'"
          [disabled]="!paymentMethod || loading || total === 0"
        >
          {{ 'ONBOARDING.REGISTER.PAYMENT.PAY' | transloco }}
        </gt-button>
        <gt-button
          (click)="confirm()"
          *ngIf="paymentMethod === 'BANK'"
          [disabled]="!paymentMethod || loading || total === 0"
        >
          {{ 'ONBOARDING.REGISTER.PAYMENT.CONTINUE' | transloco }}
        </gt-button>
      </div>
    </div>
  </ng-container>
</ion-content>
